import { render } from "./ForgotPassword.vue?vue&type=template&id=2a836b77"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"

import exportComponent from "E:\\dipto_projects\\asset_tracker\\aqc-asset-tracker-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__